import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import EnumerationList from "./EnumerationList";
import CreateEditEnumeration from "./CreateEditEnumeration"; 
import { getDefsByKeyId } from "../../../Js/Common";

const Enumeration = (props) => {

    //State
    const [enumData, setEnumData] = useState([]);
    const [isEnumeration, setIsEnumeration] = useState(true);
    const [currentKeyData, setCurrentKeyData] = useState(null);
    const [mode, setMode] = useState('create');

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // React logic hooks
    useEffect(() => {
        fetchEnumeration();
    }, [])

    // Fetch enumeration Data
    const fetchEnumeration = async () => {
        let resEnumData = await getDefsByKeyId('enumeration', userInfo.site_uuid);
        setEnumData(resEnumData.data);
        return;
    }

    // Call From Child Component Like: Enumeration & CreateEditEnumeration
    const handleEnumeration = (paramStatus, paramMode, paramKeyDataObj) => {
        setIsEnumeration(paramStatus);
        setMode(paramMode);
        setCurrentKeyData(paramKeyDataObj);
    }
    return (
        <>        
            {isEnumeration &&
                <EnumerationList
                    isEnumeration={handleEnumeration}
                    enumData={enumData}
                />
            }
            {!isEnumeration &&
                <CreateEditEnumeration
                    isEnumeration={handleEnumeration}
                    enumData={enumData}
                    currentKeyData={currentKeyData}
                    mode={mode}
                />
            }
        </>
    );
}
export default Enumeration;